import { useCargoAlerts } from './useCargoAlerts';
import { CargoUICase } from '../../../business/cargo';

export function useCargo() {
  const { isEnabledHeaderBtn, isVisibleHeaderBtn } = CargoUICase();
  const isEnabledMainDialog = isVisibleHeaderBtn && isEnabledHeaderBtn;

  useCargoAlerts();

  return {
    isEnabledHeaderBtn,
    isVisibleHeaderBtn,
    isEnabledMainDialog,
  };
}
